import { GoogleDriveError } from '@getaccept/lib-shared/src/google-drive/types/enums/google-drive-error';
import { onMounted, ref } from 'vue';
import { useToast } from '@getaccept/fried-tofu';
import type { GoogleAuthResult } from '@getaccept/lib-shared/src/google-drive/types/google-auth-result';
import { createEventHook } from '@vueuse/core';
import { GoogleDrivePickerAction } from '@getaccept/lib-shared/src/google-drive/types/google-drive-picker-action';
import { GoogleDriveHelper } from '../../document-manipulator/create-page/helpers/google-drive.helper';

declare const window: any;
declare const google: any;

export const useGoogleDrive = () => {
  const pickerLoaded = ref(false);

  const filePicked = createEventHook<{ fileName: string; fileUrl: string }>();

  const handlePick = async (data: any, authToken: string) => {
    if (data.action !== GoogleDrivePickerAction.Picked) return;

    const { id, type, name, mimeType } = data.docs[0];
    let fileUrl = `drive:${id}:${authToken}`;

    if (type !== 'file') {
      fileUrl += `:${mimeType}`;
    }
    filePicked.trigger({ fileUrl, fileName: name });
  };

  const handleError = (error: GoogleDriveError) => {
    const message = GoogleDriveHelper.getErrorMessage(error);
    useToast().toast.danger(message);
  };

  const createPicker = (authToken: string) => {
    if (!pickerLoaded.value) {
      handleError(GoogleDriveError.Fetch);
      return;
    }

    const foldersView = new google.picker.DocsView().setIncludeFolders(true).setLabel('Folders');
    const myFilesView = new google.picker.DocsView()
      .setParent('root')
      .setIncludeFolders(true)
      .setLabel('My Drive');
    const picker = new google.picker.PickerBuilder()
      .addView(foldersView)
      .addView(google.picker.ViewId.PDFS)
      .addView(google.picker.ViewId.DOCUMENTS)
      .addView(google.picker.ViewId.RECENTLY_PICKED)
      .addView(google.picker.ViewId.DOCS)
      .addView(myFilesView)
      .setOAuthToken(authToken)
      .setOrigin(`${window.location.protocol}//${window.location.host}`)
      .setDeveloperKey('AIzaSyAxkddQyDkQH8Gc7yU0KUD9n4GRhq3Rat8') //Store safely
      .setCallback(data => handlePick(data, authToken))
      .build();
    picker.setVisible(true);
    picker.na.style.zIndex = 10000000000;
  };

  const handleAuthResult = (authResult: GoogleAuthResult) => {
    if (!authResult) {
      handleError(GoogleDriveError.Authenticate);
      return;
    }
    const { access_token, error } = authResult;
    if (error) {
      handleError(GoogleDriveError.Authenticate);
      return;
    }
    createPicker(access_token);
  };

  const initializeFilePicker = async () => {
    await window.gapi.auth.authorize(
      {
        // Store Safely
        client_id: '228092608828-ghdfoedvo3aaljh9g6s9k79fej7hjpdl.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/drive.readonly',
        immediate: false,
      },
      handleAuthResult
    );
  };

  onMounted(() => {
    window.gapi.load('auth');
    window.gapi.load('picker', () => {
      pickerLoaded.value = true;
    });
  });
  return { initializeFilePicker, onFilePicked: filePicked.on };
};
